import React, { type FC } from 'react'
import { OnboardingBannerLayout } from '../../Components/OnboardingBannerLayout'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../../components/Button/Button'
import { IntegrationCategory } from '../../../../../common/integrations'
import { useTracking } from '../../../../../apps/professional-app/fa/common/tracking/hooks'
import { GrowthTrackEvent } from '../../../../../apps/professional-app/fa/common/tracking'
import { FINANCIAL_PLANNING_BANNER_COPIES } from '../../../copies/onboardingCopies'

interface FinancialPlanningOnboardingBannerProps {
  onDismiss?: () => void
}

export const FinancialPlanningOnboardingBanner: FC<FinancialPlanningOnboardingBannerProps> = ({ onDismiss }) => {
  const navigate = useNavigate()
  const { trackingClient } = useTracking()

  const onConnectClick = () => {
    trackingClient.track({ eventName: GrowthTrackEvent.CONTACTS_FINANCIAL_PLANNING_BANNER_CONNECT_CLICKED })
    navigate(`/account/integration-settings#${IntegrationCategory.PLANNING}`)
  }

  return (
    <OnboardingBannerLayout title={FINANCIAL_PLANNING_BANNER_COPIES.title} subtitle={FINANCIAL_PLANNING_BANNER_COPIES.subtitle} onDismiss={onDismiss}>
      <Button variant='grayButton' aria-label='Connect in Integrations' onClick={onConnectClick}>
        <span className={'fw-bold small text-truncate mw-100'}>Connect in Integrations</span>
      </Button>
    </OnboardingBannerLayout>
  )
}
